export const getAssetsFromLibraryQuery = /* GraphQL */ `
  query Query($organizationId: ID!, $libraryId: ID!, $page: Int!, $pageSize: Int!, $tags: [String!]) {
    assets(organizationId: $organizationId, libraryId: $libraryId, page: $page, pageSize: $pageSize, tags: $tags) {
      id
      blurhash
      thumbUrl
      url
      name
      height
      width
      views {
        id
        parentId
        name
        url
        thumbUrl
        height
        width
      }
      description
    }
  }
`
